<template lang="pug">
  .component-create-card.card
    .inner-content
      .row

        .columns
          .driver(v-if="!driver_id")
            h2.text-center Create a new card for your client
            .label Driver id
            selectize-driver(@optionSelected="setDriverId")
          .row
            .columns
              label Chip id
                input(type="text", v-model="body.chip_id", placeholder="chip id")
              label Card Active
              .switch.small
                input.switch-input(id="enabled", type="checkbox", name="enabled", v-model="body.enabled")
                label.switch-paddle(for="enabled")
                  span.show-for-sr Enabled
                  span.switch-active(aria-hidden="true") Yes
                  span.switch-inactive(aria-hidden="true") No
            .columns
              label Card name
                input(type="text", v-model="body.name", placeholder="card name")

              label Standard
                select(v-model="body.standard")
                  option RAW
                  option 2-ROTATED


      .row
        .columns.text-center
          button.button(type="button", v-on:click="addCard") Add card
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from 'src/maggieHelper'

  import DatePicker from "components/structure/DatePicker"
  import Reservation from 'components/backoffice/Reservation'
  import SelectizeDriver from "./lists/selectize/SelectizeDriver";

  export default {
    name: "CreateCard",
    components: {
      SelectizeDriver,
      KeplerBackofficeSdk,
      DatePicker,
      Reservation
    },
    data() {
      return {
        drivers: [],
        body: {
          driver_id: null,
          chip_id: null,
          name: null,
          enabled: true,
          standard: "2-ROTATED"
        }
      }
    },
    created() {
      this.body.driver_id = this.driver_id
    },
    methods: {
      addCard() {
        KeplerBackofficeSdk.cards.make(this.body, () => {
          MaggieHelper.notification('card-result', 'Card added')
          this.$emit('cardCreated')
          if(this.$props.driver_id === undefined ){
            this.$router.go(-1)
          }else {
            this.$emit('addCard', 'added')
          }
        })
      },
      setDriverId(driver) {
        this.body.driver_id = driver.id
      },
    },
    props: ['driver_id']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// CreateCard.vue?7b708d29